import React from 'react';
import { useParams } from 'react-router-dom';
import Theme404 from '../../layout/404';
import VehicleList from './vehicle_list';
import VehicleView from './vehicle_view';

export default function Vehicle_management() {
  let { slug = 'list' } = useParams();

  let ActualPage: any;
  switch (slug) {
    case 'list':
      ActualPage = VehicleList;
      break;

    case 'view':
      ActualPage = VehicleView;
      break;

    default:
      ActualPage = Theme404;
      break;
  }

  return <>{<ActualPage />}</>;
}

